module.exports = __webpack_public_path__ + "img/ringe_btn.3a28ba1d.jpg";